import React, { useEffect, useState } from "react";
import { useAppSelector } from "../app/hooks";
import { sendDataToAndroid } from "../utils/androidBridge";

const SuccessRedirect: React.FC = () => {
    const { consentHandle } = useAppSelector((state) => state.consent);
    const [timeLeft, setTimeLeft] = useState(5);

    useEffect(() => {
        // Hand off to Android
        const payload = {
            type: "LINKING_SUCCESS",
            consentHandle: consentHandle,
            status: "SUCCESS"
        };
        sendDataToAndroid(payload);

        // Countdown timer for user feedback
        const timerId = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timerId);

                    // Execute Redirect
                    const consenProUrl = process.env.REACT_APP_CONSENPRO_URL || "https://consenpro.uat.camsfinserv.com";
                    const handle = consentHandle || "mock-handle";
                    window.location.href = `${consenProUrl}?consentId=${handle}`;
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timerId);
    }, [consentHandle]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-fin-bg relative overflow-hidden text-white">

            {/* Background design elements */}
            <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-fin-primary/10 rounded-full blur-3xl"></div>

            <div className="w-full max-w-sm flex flex-col items-center z-10 animate-fade-in-up">

                {/* Success Checkmark Circle */}
                <div className="w-24 h-24 bg-fin-surface rounded-full flex items-center justify-center mb-8 shadow-2xl shadow-fin-primary/5 border-4 border-fin-border relative">
                    <svg className="w-12 h-12 text-fin-primary drop-shadow-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 13l4 4L19 7" />
                    </svg>

                    {/* Spinning ring around the checkmark */}
                    <div className="absolute inset-0 rounded-full border-[3px] border-fin-primary border-l-transparent animate-spin-slow opacity-20"></div>
                </div>

                <div className="text-center mb-10 w-full px-4">
                    <h2 className="text-2xl font-black text-white leading-tight mb-3 tracking-tight">
                        Account linked!
                    </h2>
                    <p className="text-[15px] text-fin-slate mt-2 leading-relaxed">
                        Great! We've successfully linked your accounts. You'll be redirected back automatically in just a moment.
                    </p>
                </div>

                {/* Redirecting Progress Pill */}
                <div className="flex items-center gap-3 bg-fin-surface px-6 py-3.5 rounded-full shadow-xl border border-fin-border">
                    <svg className="w-4 h-4 text-fin-primary animate-spin" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span className="text-sm font-bold text-white tracking-wide">
                        Redirecting in <span className="text-fin-primary">{timeLeft}s</span>
                    </span>
                </div>

            </div>
        </div>
    );
};

export default SuccessRedirect;
